// extracted by mini-css-extract-plugin
export default {"root":"CategoryLinks_root__m+Wmb","categoryLink":"CategoryLinks_categoryLink__-5YY3"};